module.exports = "/_next/static/images/new-york-46195fd1b0c1ad5ea29ec8b4f7d7ebcf.svg";